export default "__VITE_ASSET__BoiJ$Uk7__"